export default "__VITE_ASSET__CYpZJJ3b__"